import { auth } from '@/lib/firebase/config';
import { AuthContext } from '@/providers/AuthProvider/AuthContext';
import { Protected } from '@/providers/AuthProvider/Protected';
import type { User } from '@/providers/AuthProvider/User';
import { UserFunctionsContext } from '@/providers/AuthProvider/UserFunctionsContext';
import { useCallback, useEffect, useState } from 'react';
import type { PropsWithChildren } from 'react';

export const AuthProvider: React.FC<PropsWithChildren> = (props) => {
  const [user, setUserState] = useState<User | null>(() => {
    let tmpUser = null;
    const localStorageUser = localStorage.getItem('sauna100user');

    // TODO: zod でパースする
    if (localStorageUser !== null)
      tmpUser = JSON.parse(localStorageUser) as User;

    return tmpUser;
  });

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!user);

  const setUser = useCallback((user: User | null) => {
    if (user === null) return;

    localStorage.setItem('sauna100user', JSON.stringify(user));
    setUserState(user);
  }, []);

  useEffect(() => {
    try {
      auth.onAuthStateChanged(async (firebaseUser) => {
        const authToken = (await firebaseUser?.getIdToken()) || '';

        const tmpUser: User | null = firebaseUser
          ? {
              ...user,
              firebaseUser,
              authToken,
              expirationDate: null,
            }
          : null;

        // TODO: BEからユーザー情報を取得して判定する
        setIsAuthenticated(!!firebaseUser);
        setUser(tmpUser);
        console.log('useEffect user', tmpUser);
        localStorage.setItem('sauna100user', JSON.stringify(tmpUser));
      });
    } catch (error) {
      setUser(null);
      throw error;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setUser]);

  useEffect(() => {
    const isAuthenticated = user !== null;
    setIsAuthenticated(isAuthenticated);
  }, [user]);

  return (
    <AuthContext.Provider
      value={{ user, isAuthenticated, error: null, isLoading: false }}
    >
      <UserFunctionsContext.Provider value={{ setUser }}>
        <Protected {...props} />
      </UserFunctionsContext.Provider>
    </AuthContext.Provider>
  );
};
